const productCategory = [
    { id : 1, label : "Earthenware", value: "earthenware"},
    { id : 2, label : "Stoneware", value: "stoneware"},
    { id : 3, label : "Raku", value: "raku"},
    { id : 4, label : "Majolica", value: "majolica"},
    { id : 5, label : "Bonechina", value: "bonechina"},
    { id : 6, label : "Faience", value: "faience"},
    { id : 7, label : "Delftware", value: "delftware"},
    { id : 8, label : "Sgraffito", value: "sgraffito"},
    { id : 9, label : "Celtic", value: "celtic"},
    { id : 10, label : "Redware", value: "redware"},
    { id : 11, label : "TMiniGlass", value: "tinyglass"},
    { id : 12, label : "TMiniClay", value: "tinyclay"},
  
  

    






]

export default productCategory